<app-navbar></app-navbar>
<div class="container">
    <div class="card mt-3 mb-3"
        *ngIf="!fetchinData">
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <div align="left"
                        style="padding-left: 20px">
                        <p style="font-size: 26px">Administration</p>
                    </div>
                    <div class="list-group list-group-flush">
                        <ng-container *ngFor="let item of items">
                            <button [class.active]="selectedItem === item.Url"
                                (click)="selectItem(item.Url)"
                                class="newA linkStyle list-group-item list-group-item-action ">{{item.Name}}</button>
                        </ng-container>
                        <!-- <button class="newA linkStyle list-group-item list-group-item-action active">Governing
                            Body</button> -->
                    </div>
                </div>
                <div class="col-md-8">
                    <div style="min-height: 800px;">
                        <div>
                            <h3>{{selectedItemName}}</h3>
                            <hr>
                            <div class="container"
                                *ngIf="selectedItem && selectedItem === 'governing-body'">
                                <ng-container *ngIf="GBs == null"
                                    class="spinner-overlay">
                                    <span class="fetching-data-text">No Data Found</span>
                                </ng-container>

                                <div class="container" *ngIf="selectedItem && selectedItem === 'governing-body'">
                                    <ng-container *ngIf="GBs == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                
                                   <!-- First Row: 1 Image -->
<div class="row justify-content-center" *ngIf="GBs1 != null">
    <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="single-team-box">
            <div class="image">
                <img [src]="GBs1.ImagePath" alt="team" style="width: 100%; height: auto;" />
            </div>
            <div class="content">
                <h3 style="color: black;">{{GBs1.Name}}</h3>
                <span>{{GBs1.Rank}}</span>
            </div>
        </div>
    </div>
</div>

<!-- Second Row: 2 Images -->
<div class="row justify-content-center" *ngIf="GBs2 != null">
    <ng-container *ngFor="let item of GBs2">
        <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="single-team-box">
                <div class="image">
                    <img [src]="item.ImagePath" alt="team" style="width: 100%; height: auto;" />
                </div>
                <div class="content">
                    <h3 style="color: black;">{{item.Name}}</h3>
                    <!-- <span>{{item.InstitutePosition}}</span> -->
                    <span>{{item.Rank}}</span>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<!-- Third Row: 3 Images -->
<div class="row justify-content-center" *ngIf="GBs3 != null">
    <ng-container *ngFor="let item of GBs3">
        <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="single-team-box">
                <div class="image">
                    <img [src]="item.ImagePath" alt="team" style="width: 100%; height: auto;" />
                </div>
                <div class="content">
                    <h3 style="color: black;">{{item.Name}}</h3>
                    <!-- <span>{{item.InstitutePosition}}</span> -->
                     <span>{{item.Rank}}</span>
                </div>
            </div>
        </div>
    </ng-container>
</div>

                                </div>
                            </div>
                            <div class="container"
                                *ngIf="selectedItem && selectedItem === 'teacher-information'">
                                <ng-container *ngIf="TeacherInfo == null"
                                    class="spinner-overlay">
                                    <span class="fetching-data-text">No Data Found</span>
                                </ng-container>

                                <div class="row justify-content-center"
                                    *ngIf="TeacherInfo != null">
                                    <ng-container *ngFor="let item of TeacherInfo">
                                        <div class="col-lg-4 col-md-6 col-sm-6">
                                            <div class="single-team-box">
                                                <div class="image">
                                                    <img [src]="item.ImageLink"
                                                        alt="team">
                                                </div>
                                                <div class="content">
                                                    <h3>{{item.EmployeeName}}
                                                    </h3>
                                                    <span> {{item.Designation}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="container"
                                *ngIf="selectedItem && selectedItem !== 'governing-body' && selectedItem !== 'teacher-information'">
                                <ng-container *ngIf="GBms == null"
                                    class="spinner-overlay">
                                    <span class="fetching-data-text">No Data Found</span>
                                </ng-container>

                                <div class="row justify-content-center">
                                    <article class="col-md-12 text-justify  p-4 ">
                                        <div><img alt="Message"
                                                class="img-thumbnail img-fluid"
                                                [src]="GBms1.GBImagePath"
                                                style="float:left; height:220px; margin:0px 15px 10px 0px; width:200px">
                                        </div>

                                        <p style="text-align: justify;"
                                            [innerHTML]="GBms1.DetailsEn">
                                        </p>

                                        <!-- <p><strong></strong><br></p> -->
                                    </article>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
    </div>
    <div aria-hidden="true"
        *ngIf="fetchinData"
        class="col-lg-12 col-md-12">
        <h5 class="placeholder-glow">
            <span class="placeholder col-12"
                style="height: 200px;"></span>
        </h5>
    </div>
</div>


